import React from "react";
import { PRODUCTS } from "../../products";
import { Product } from "../shop/product";
import './shop.css';
import pmLogo from "../../assets/logo.png";

const Rangoli = () => {

    return (    
    <div className="shop">
        <div className="heading">
            <h2>Pooja Creations</h2>
            <img src={pmLogo} alt="Company logo" />
        </div>
        <h3>Decorative Rangoli</h3>
        <div className="products"> {PRODUCTS.rangoli.map((product) => (
        <Product key={product.id} data={product} />
        ))}
        </div>
        <div className="bottom">
            <h3>Click the cart icon on top right to checkout</h3>
        </div>
        
    </div>
    )
}

export default Rangoli;